import { useCallback } from 'react';
import { ShadeClearIcon, ShadeRoot } from "./styles";
import { ShadeSize } from "./types";
import { jsx as _jsx } from "react/jsx-runtime";
export var Shade = function Shade(_ref) {
  var shade = _ref.shade,
    currentShade = _ref.currentShade,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? ShadeSize.Medium : _ref$size,
    testId = _ref.testId,
    onShadeClick = _ref.onShadeClick;
  var onClick = useCallback(function () {
    onShadeClick === null || onShadeClick === void 0 || onShadeClick(shade);
  }, [onShadeClick, shade]);
  return /*#__PURE__*/_jsx(ShadeRoot, {
    currentShade: currentShade,
    isClickable: onShadeClick !== undefined,
    shade: shade,
    size: size,
    "data-testid": testId,
    onClick: onClick,
    children: shade.canBeSold ? null : /*#__PURE__*/_jsx(ShadeClearIcon, {
      shade: shade,
      size: size
    })
  });
};
//# sourceMappingURL=Shade.js.map